import MUIContainer from '@/components/MUI-Components/MUI-Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import DisplayImage from '../display-image';
import {colors, fontFamily, fontSize, fontWeight, spacing} from '@/styles/tokens';

// Migrated from globals.scss `.demand-feature-card-wrapper` (+ tabScreen override, max-width: 768px).
const sxCardWrapper = {
    marginBottom: '30px', // no exact spacing-token match
    '@media (max-width: 768px)': {
        marginBottom: 'unset'
    }
};

// Migrated from globals.scss `.demand-feature-card` (+ `:hover` and tabScreen override).
const sxCard = {
    boxShadow: '0 0 11px 0 rgba(0, 0, 0, 0.1)', // no exact shadows.* token match
    height: '100%',
    backgroundColor: colors.background.default,
    position: 'relative',
    transform: `translateY(${spacing[48]})`,
    transition: 'transform 0.5s ease-in-out 0s', // no exact transition-token match
    willChange: 'transform',
    '&:hover': {
        transform: 'translateY(0)'
    },
    // `!important` preserved from globals.scss: `:hover`'s translateY(0) has higher
    // specificity than a plain class match, so only `!important` can force this
    // media override to win below 768px even while hovered.
    '@media (max-width: 768px)': {
        transform: 'none !important'
    }
};

// Migrated from globals.scss `.on-demand-card-header`.
const sxCardHeader = {
    fontFamily: fontFamily.heading,
    fontWeight: fontWeight.semibold,
    fontSize: fontSize[20]
};

// Migrated from globals.scss `.on-demand-card-body`.
const sxCardBody = {
    fontFamily: fontFamily.body,
    fontSize: fontSize[16],
    a: {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }
};

const DemandKeyFeature = (props: any) => {
    const {heading, subheading, contentData} = props;
    return (
        <Box>
            <MUIContainer>
                <Box className="spectrum-header-wrapper solutions">
                    <Typography className="spectrum-heading color-black text-align-left" component="h2">
                        {heading}
                    </Typography>
                    <Box className="divder-wrapper">
                        <hr className="divider-line divider-line-left" />
                    </Box>
                    {subheading && (
                        <Box className="sub-heading-box" pb={2}>
                            <Typography className="spectrum-sub-heading color-black spacing text-align-left">{subheading}</Typography>
                        </Box>
                    )}
                </Box>
                <Grid container spacing={3} sx={sxCardWrapper}>
                    {contentData?.map((item: any, index: number) => (
                        <Grid item key={index + 1} md={4} sm={6} xs={12}>
                            <Box sx={sxCard} px={2} py={3}>
                                <Box>
                                    <Box display="flex" alignItems="center" gap={3}>
                                        <DisplayImage alt={item.heading} src={item.icon} />
                                        <Typography component="h4" sx={sxCardHeader}>
                                            {item.heading}
                                        </Typography>
                                    </Box>
                                    <Typography component="p" sx={sxCardBody} my={2}>
                                        {item.subheading}
                                    </Typography>
                                </Box>
                                <Box>
                                    {item.subListing?.map((subItem: any, subIndex: number) => (
                                        <Box key={subIndex + 1} mb={1.3}>
                                            <Typography component="h5" fontWeight="bold">
                                                <Typography component="span" mr={1}>
                                                    ●
                                                </Typography>
                                                {subItem.header}
                                            </Typography>
                                            <Typography component="p" sx={sxCardBody}>
                                                {subItem.subheader}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </MUIContainer>
        </Box>
    );
};

export default memo(DemandKeyFeature);
